import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, of, switchMap } from 'rxjs';
import * as CryptoJS from 'crypto-js';
import { LoginUser } from 'src/app/modules/login/models/auth';
import { instanceToPlain } from 'class-transformer';
import { UrlsConstants } from 'src/app/core/constants/urls.constants';
import { LoginRequest } from 'src/app/modules/login/models/login-request.model';
import { JwtService } from 'src/app/services/utils/jwt.service';
@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private apiUrl = `${environment.sgcApi}`;
  private clientId = environment.sgcClientId;
  private keyWord = environment.sgcKeyWord;
  private policyRoute = 'policy';

  constructor(
    private jwtService: JwtService,
    private handler: HttpBackend,
  ) { }

  getHeaders(): Observable<HttpHeaders>{
    return this.getValidToken().pipe(
      switchMap((token) => {
        return of(this.createHeadersWithToken(token));
      })
    );
  }

  setTokenInLocalStorage(jwt) {
    const item = {
      token: jwt,
    };
    localStorage.removeItem('jwt');
    localStorage.setItem('jwt', JSON.stringify(item));
  }

  login(auth: LoginUser) {
    const httpClientBk = new HttpClient(this.handler);
    const body = instanceToPlain(auth);
    const headers = this.createHeaders();
    let endpoint = `${this.apiUrl}${UrlsConstants.LOGIN_PATH}`;
    return httpClientBk.post<string>(endpoint, body, { headers: headers });
  }

  loginSgc1(loginRequest: LoginRequest) {
    const httpClientBk = new HttpClient(this.handler);
    const body = instanceToPlain(loginRequest);
    const headers = this.createHeaders();
    let endpoint = `${this.apiUrl}${UrlsConstants.LOGIN_SGC1_PATH}`;
    return httpClientBk.post<string>(endpoint, body, { headers: headers });
  }

  getValidToken(): Observable<string>  {
    const jwt = JSON.parse(this.getTokenFromLocalStorage());
    const tokenAboutToExpire = this.isTokenAboutToExpire(jwt.token);
    if(tokenAboutToExpire) {
      this.refreshToken(jwt.token).subscribe((token) => {
        this.setTokenInLocalStorage(token);
        return token;
      });
    }
    return of(jwt.token);
  }

  logout() {
    localStorage.removeItem('jwt');
  }

  getUserLevel(token) {
    const decodedToken = this.jwtService.decodeToken(token);
    return decodedToken['level'];
  }

  isTokenExpired(token) {
    const exp = this.jwtService.decodeToken(token).exp
    const expiry = new Date(exp * 1000); //Timestamp in millisecs
    return (new Date() > expiry)
  }

  getTokenFromLocalStorage() {
    return localStorage.getItem('jwt');
  }

  getUserNameFromToken() {
    let token = this.getTokenFromLocalStorage();
    return this.jwtService.decodeToken(token)['name'];
  }

  getUserFromToken() {
    let token = this.getTokenFromLocalStorage();
    return this.jwtService.decodeToken(token)['userAM'];
  }

  getLevelFromToken() {
    let token = this.getTokenFromLocalStorage();
    return this.jwtService.decodeToken(token)['level'];
  }

  private refreshToken(token): Observable<string>  {
    const httpClientBk = new HttpClient(this.handler);
    const headers = this.createHeadersWithToken(token);
    let endpoint = `${this.apiUrl}${this.policyRoute}/refreshToken`;
    return httpClientBk.post<any>(endpoint, null, { headers: headers });
  }

  private createHeadersWithToken(token): HttpHeaders {
    let headers = this.createHeaders();
    headers = headers.append('Authorization', 'Bearer ' + token);
    return headers;
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('x-wc-webhook-signature', this.generateHashmap().toUpperCase());
    headers = headers.append('clientId', this.clientId);
    headers = headers.append('secuence', this.getSecuence());
    return headers;
  }


  private isTokenAboutToExpire(token) {
    const exp = this.jwtService.decodeToken(token).exp
    const expiry = exp * 1000;
    const refreshLimit = 300000; //5 mins
    const currentDate = Date.now();
    const minsLeftToExpire = expiry - currentDate;
    return (!this.isTokenExpired(token) && minsLeftToExpire < refreshLimit);
  }

  private generateHashmap() {
    const secuence = this.getSecuence();
    const keyByte = secuence + this.keyWord;
    const hash = CryptoJS.HmacSHA256(this.clientId, keyByte);
    const hexString = CryptoJS.enc.Hex.stringify(hash);
    return hexString;
  }

  private getSecuence() {
    const hours = new Date().getHours();
    const minutes = new Date().getMinutes();
    return `${hours}:${minutes}`;
  }
}
